import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'

import { withTranslation } from 'react-i18next'
import { simplePointerEventsData } from '../../helpers/util'

import './Tooltip.scss'


export class TooltipComponent extends PureComponent {
  static defaultProps = {
    placement: 'top',
    prefixCls: 'tooltip',
    overlayClassName: '',
    arrowContent: <div className="tooltip-arrow__inner" />,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    destroyTooltipOnHide: true,
    isHidden: false
  }
  
  static propTypes = {
    placement: PropTypes.string,
    prefixCls: PropTypes.string,
    children: PropTypes.node.isRequired,
    translationKey: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    offset: PropTypes.array,
    overlayClassName: PropTypes.string,
    arrowContent: PropTypes.element,
    isHidden: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      offset: []
    }
  }

  componentDidMount() {
    const { placement } = this.props

    switch(placement) {
      case 'bottomRight':
      case 'bottomLeft':
        this.setState({ offset: [0, 12] })
        break
      case 'bottom':
        this.setState({ offset: [0, 10] })
        break
      case 'top':
        this.setState({ offset: [0, -10] })
        break
      case 'right':
        this.setState({ offset: [12, 0] })
        break
      default:
        this.setState({ offset: [] })
    }
  }

  render() {
    const { 
      children, 
      t,
      translationKey,
      isHidden
    } = this.props
    
    const { offset } = this.state

    return simplePointerEventsData.isTouch || isHidden ? 
      (
        <>
          {children}
        </>
      )
      : (
        <Tooltip
          {...this.props}
          align={{ offset }}
          overlay={ <span>{t(translationKey)}</span> }
        >
          {children}
        </Tooltip>
      )
  }
}

export default withTranslation()(TooltipComponent)
